import { render } from "./ProductsComponent.vue?vue&type=template&id=676d6912&scoped=true"
import script from "./ProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductsComponent.vue?vue&type=script&lang=js"

import "./ProductsComponent.vue?vue&type=style&index=0&id=676d6912&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676d6912"]])

export default __exports__